import { FormEventHandler, ReactNode } from "react";

import Card from "ds/components/Card";

type AttachCloudFormCardFormProps = {
  children: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement>;
};

const AttachCloudFormCardForm = ({ children, onSubmit }: AttachCloudFormCardFormProps) => {
  return (
    <form onSubmit={onSubmit}>
      <Card variant="secondary" margin="large 0" contentGap="large">
        {children}
      </Card>
    </form>
  );
};

export default AttachCloudFormCardForm;
